module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/categorias-gastos/subcategorias-gastos/subcategorias-gastos.component.scss
// module id = ./src/app/administracion/categorias-gastos/subcategorias-gastos/subcategorias-gastos.component.scss
// module chunks = main